import {
  FilterMode,
  AssociatedDocumentEdition_OrderBy,
  AssociatedDocumentEdition,
  SortOrder,
  AssociatedDocumentEdition_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const associatedDocumentEditionService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.associatedDocumentEditionOne({ id });
    return result.associatedDocumentEditionOne as AssociatedDocumentEdition;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AssociatedDocumentEdition_OrderBy[] | null = null,
    filter: AssociatedDocumentEdition_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AssociatedDocumentEdition_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.associatedDocumentEditionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.associatedDocumentEditionListWithOffset
    ) as AssociatedDocumentEdition[];
    return { list, orderBy };
  },
};
